import { render, staticRenderFns } from "./config-us.vue?vue&type=template&id=102083bd"
import script from "./config-us.vue?vue&type=script&lang=js"
export * from "./config-us.vue?vue&type=script&lang=js"
import style0 from "./config-us.vue?vue&type=style&index=0&id=102083bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports